import { Input as BaseInput } from 'lp-components'
import { withFormikAdapter } from 'utils'

export default withFormikAdapter()(BaseInput)
